<script>

    import { createEventDispatcher } from 'svelte';
    import axios from 'axios';

    export let accept;
    export let maxSize;
    export let maxFiles;
    export let url;
    export let title = 'Add';
    export let validation;

    export let uploaded_files = 0;

    let fileinput;
    let uploading = 0;
    let file_errors = [];

    const dispatch = createEventDispatcher();

    const onFileSelected = (e) => {
        const files = e.target.files;
        if (!files.length) return;

        if (maxFiles && (uploaded_files + files.length) > maxFiles) {
            file_errors = ['Please upload a maximum of '+maxFiles+ ' files.'];
            return;
        }

        file_errors = [];
        uploading = files.length;

        Array.from(files).forEach(file => {
            const mime = file.type;
            const name = file.name;

            if (maxSize && file.size/1024/1024 > maxSize) {
                file_errors = [...file_errors, `${name}: File exceeds the maximum allowed size (${maxSize} MB).`];
                uploading = uploading - 1;
                return;
            }

            let data = new FormData();
            data.append('file', file);
            data.append('type', validation);

            /*
            fetch(url, {
                method: 'POST',
                body: data,
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    'X-CSRF-Token': token
                },
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    dispatch('fileUploaded', data.info);
                } else {
                    file_errors = [...file_errors, `${name}: ${data.message}`];
                }
            })
            .catch(error => {
                file_errors = [...file_errors, `${name}: Upload failed`];
            })
            .finally(() => uploading = uploading - 1);
            */

            axios.post(url, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(function (response) {
                if (response.status != 200) {
                    // console.log(response);
                    file_errors = [...file_errors, `${name}: Upload failed`];
                } else {
                    if (response.data.success) {
                        dispatch('fileUploaded', response.data.info);
                    } else {
                        file_errors = [...file_errors, `${name}: ${response.data.message}`];
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                file_errors = [...file_errors, `${name}: Upload failed`];
            })
            .finally(() => uploading = uploading - 1);

        });
    }


    </script>

    <button type="button" class="btn btn-light btn-lg rounded" on:click={() => fileinput.click()} disabled={uploading > 0}>
        <i class="me-2 {uploading > 0 ? 'fal fa-spinner fa-spin' : 'fas fa-plus'}"></i> {title}
    </button>

    {#if file_errors.length}
    <ul class="list-unstyled mt-2">
        {#each file_errors as msg}
        <li class=text-danger>{msg}</li>
        {/each}
    </ul>
    {/if}

    <input style="display:none" type="file" multiple {accept} on:change={onFileSelected} bind:this={fileinput}>
